import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid } from '@mui/material';
import { OverlayComponent } from '../common/OverlayComponent';
import PrimaryButton from './PrimaryButton';
import {
  Header20,
  Header22,
  Header46,
  Header60,
  Subheader14,
  Subheader18,
} from '../common/Typography';
import { BACKGROUNDS } from './constants';
import FORMAT_SIZES from '../common/constants/FormatSizes';
import { useGetFormat } from '../app/useGetFormat';
import Lottie from 'react-lottie';
import Success from '../../assets/lotties/success.json';
import TextFader from '../common/CyclingText';

const Heading = styled.div`
  h1 {
    line-height: 1.1 !important;
  }

  h2 {
    margin-top: ${({ isMobile }) => (isMobile ? 1.2 : 2)}rem;
    margin-bottom: ${({ isMobile }) => (isMobile ? 2 : 2.5)}rem;
  }
  width: 100%;
`;

const HeadingWrapper = styled(Grid)`
  margin: 1rem !important;
  text-align: center !important;
`;

const ActionContainer = styled.div`
  margin: 1rem !important;
  text-align: center !important;
`;

const contents = [
  'MORE CLIENTS',
  'IDEAS LAUNCHED',
  'TO THE NEXT STEP',
  'SH*T HANDLED',
];

const PageContainer = styled(Grid)``;

function getRandomItem(arr) {
  if (!arr.length) return null; // handle empty array
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
}

const TypeFormCreateAccount = () => {
  const format = useGetFormat();
  const isMobile = format === FORMAT_SIZES.MOBILE;
  const background = BACKGROUNDS[0];
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: Success,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <OverlayComponent background={background.background}>
      <PageContainer container justifyContent="center">
        <HeadingWrapper item md={12} isMobile={isMobile}>
          <Heading isMobile={isMobile}>
            {!isMobile && (
              <>
                <Header60 component="h1">WeSuap</Header60>
                <Lottie options={defaultOptions} height={200} width={200} />
                <Header22>Profile created!</Header22>
                <Subheader18 component="h3">
                  See your profile by sending us a message
                </Subheader18>
              </>
            )}
            {isMobile && (
              <>
                <Header46 component="h1">WeSuap</Header46>
                <Lottie options={defaultOptions} height={200} width={200} />
                <Header20>Profile Created!</Header20>
                <Subheader14 component="h3">
                  See your profile by sending us a message
                </Subheader14>
              </>
            )}
            <ActionContainer>
              <PrimaryButton
                backgroundColor={background.buttonColor}
                hoverColor={background.hoverColor}
                variant="contained"
                width="unset"
                onClick={() =>
                  (window.location = `sms:${process.env.REACT_APP_SMS_NUMBER}&body=hi`)
                }
              >
                Send message
              </PrimaryButton>
            </ActionContainer>
          </Heading>
        </HeadingWrapper>
      </PageContainer>
    </OverlayComponent>
  );
};

TypeFormCreateAccount.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
export default TypeFormCreateAccount;
